<template>
  <div id="lm-wait">

<!--
<LmMarca  :itemsMarcasTodas="itemsMarcasTodas" :options="element" />

  <b-form-input list="my-list-id" v-model="options.companyName" class="my-3" placeholder="Seleccione una opción"></b-form-input>
-->

<b-form-group
      id="imagen"
      label-cols-sm="2"
      label-cols-lg="1"
      label="Imagen"
      label-for="input-horizontal"
      class="align-items-center"
    >

      <LmUploadFiles
            label=""
            ref="lmUploadFiles"
            class="mb-2"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
        />

        </b-form-group>

<b-form-group
      id="titulo"
      label-cols-sm="2"
      label-cols-lg="1"
      label="Título"
      label-for="input-horizontal"
      class="align-items-center"
    >

     <LmTextInput id="titulo"
        list="my-list-id"
        v-model="options.title"
        @input="inputDataList" class="mb-0" />

    </b-form-group>

<b-form-group
      id="link"
      label-cols-sm="2"
      label-cols-lg="1"
      label="Nombre"
      label-for="input-horizontal"
      class="align-items-center"
    >

     <LmTextInput  list="my-list-id"
        v-model="options.linkName"
        @input="inputDataList" class="mb-0" />

     </b-form-group>

<b-form-group
      id="link"
      label-cols-sm="2"
      label-cols-lg="1"
      label="URL"
      label-for="input-horizontal"
      class="align-items-center"
    >

     <LmTextInput list="my-list-id"
        v-model="options.linkUrl"
        @input="inputDataList" class="mb-0" />

    </b-form-group>

  </div>
</template>

<script>
import store from '@/store'

import LmSelect from '@/components/form/elements/LmSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmUploadFiles from '@/components/LmUploadFiles'

export default {
  components: {
    LmSelect,
    LmTextInput,
    LmUploadFiles
  },
  data () {
    return {
      files: [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      }
    }
  },
  props: {
    form: {
      dataList: ''
    },
    apiUrlPath: '',
    dataValue: '',
    options: {
      type: Object,
      id: '',
      title: '',
      default: () => ({
        disabledOption: 'Seleccione una acción',
        content: []
      })
    }
  },
  methods: {

    setForm () {
      if (this.options.image) {
        const fileOption = {
          size: 100000
        }

        let urlImage = this.apiUrlPath + this.options.image
        this.$refs.lmUploadFiles.lmManuallyAddFile(fileOption, urlImage)
      }
    },
    fileCreated (file, response) {
      if (response) {
        this.options.image = response.path
        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileRemoved (file, error, xhr) {
      this.files = []
      this.$emit('fileRemovedImage', this.index)
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.enable()
    }
  },
  mounted () {
    this.setForm()
  }
}
</script>
